{
  "name": "concept-ev-app",
  "version": "0.0.345",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build:prod": "ng build --configuration production",
    "build:test": "ng build --configuration test",
    "build:dev": "ng build --configuration development_deploy",
    "cy:dev": "start-server-and-test start http://localhost:4200 cy:open",
    "cy:open": "npx cypress open",
    "cy:test": "npx cypress run --browser chrome --headless --reporter cypress-multi-reporters --reporter-options configFile=cypress-reporter-config.json",
    "cy:ci": "start-server-and-test start http://localhost:4200 cy:test",
    "cy:ci:dev": "npx cypress run --env type-of-environment=development --browser chrome --headless --reporter cypress-multi-reporters --reporter-options configFile=cypress-reporter-config.json ",
    "cy:ci:test": "npx cypress run --env type-of-environment=testing --browser chrome --headless --reporter cypress-multi-reporters --reporter-options configFile=cypress-reporter-config.json ",
    "cy:ci:prod": "npx cypress run --env type-of-environment=production --browser chrome --headless --reporter cypress-multi-reporters --reporter-options configFile=cypress-reporter-config.json ",
    "watch": "ng build --watch --configuration development",
    "test": "ng test",
    "pretest": "ng test --watch=false --browsers=ChromeHeadless",
    "pretest-cover": "ng test --watch=false --browsers=ChromeHeadless --code-coverage",
    "generate-api": "openapi --input http://localhost:8080/api/openapi.json --output ./src/api --client angular",
    "generate-api:dev": "openapi --input https://dev-conceptev.awsansys3np.onscale.com/api/openapi.json --output ./src/api --client angular",
    "generate-api:test": "openapi --input https://test-conceptev.awsansys3np.onscale.com/api/openapi.json --output ./src/api --client angular",
    "lint": "gts lint",
    "fix": "eslint --fix ./**/*.ts"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^20.3.19",
    "@angular/cdk": "^20.2.14",
    "@angular/common": "^20.3.19",
    "@angular/compiler": "^20.3.19",
    "@angular/core": "^20.3.19",
    "@angular/forms": "^20.3.19",
    "@angular/platform-browser": "^20.3.19",
    "@angular/platform-browser-dynamic": "^20.3.19",
    "@angular/router": "^20.3.19",
    "@ansys-internal/awc-angular": "5.8",
    "@ansys-internal/awf-angular": "^1.28.0",
    "@ansys-internal/awf-data-providers": "^2.1.0",
    "@ansys-internal/awf-js": "^1.27.0",
    "@ansys-internal/cloud-angular-client": "^3.0.0",
    "@ansys-internal/portal-bff-angular-client": "^2.1.0",
    "@azure/msal-angular": "^3.0.10",
    "@azure/msal-browser": "^3.2.0",
    "aws-amplify": "^5.3.3",
    "highlight.js": "^11.11.1",
    "jwt-decode": "^3.1.2",
    "marked": "^15.0.7",
    "rxjs": "~7.8.0",
    "semver": "^7.6.2",
    "tslib": "^2.3.0",
    "zone.js": "~0.15.1"
  },
  "devDependencies": {
    "@angular/build": "^20.3.24",
    "@angular/cli": "^20.3.24",
    "@angular/compiler-cli": "^20.3.19",
    "@ansys-internal/awf-cypress": "^1.4.2",
    "@hypercubed/cypress-gherkin": "^2.1.1",
    "@types/jasmine": "~4.3.0",
    "@types/node": "^22.13.9",
    "@types/plotly.js-dist-min": "^2.3.1",
    "@typescript-eslint/eslint-plugin": "^5.62.0",
    "@typescript-eslint/parser": "^5.62.0",
    "cypress": "^13.15.0",
    "cypress-multi-reporters": "^2.0.5",
    "cypress-terminal-report": "^7.1.0",
    "dd-trace": "^5.61.1",
    "eslint": "^8.47.0",
    "eslint-config-standard-with-typescript": "^34.0.1",
    "eslint-plugin-import": "^2.27.5",
    "eslint-plugin-n": "^15.7.0",
    "eslint-plugin-promise": "^6.1.1",
    "jasmine-core": "~4.6.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.0.0",
    "karma-junit-reporter": "^2.0.1",
    "mocha-junit-reporter": "^2.2.1",
    "mochawesome": "^7.1.3",
    "openapi-typescript-codegen": "github:philipjusher/openapi-typescript-codegen",
    "start-server-and-test": "^2.0.8",
    "typescript": "~5.8.3"
  },
  "optionalDependencies": {
    "@lmdb/lmdb-linux-x64": "^3.4.3",
    "@nx/nx-darwin-arm64": "^21.6.5",
    "@nx/nx-darwin-x64": "^21.6.5",
    "@nx/nx-linux-x64-gnu": "^21.6.5",
    "@nx/nx-win32-x64-msvc": "^21.6.5",
    "@rollup/rollup-linux-x64-gnu": "^4.52.4"
  },
  "overrides": {
    "keycloak-angular": "20.0.0",
    "@apollo/client": "^4.0.0",
    "apollo-angular": "^12.0.0",
    "axios": ">=1.15.2",
    "protobufjs": ">=7.5.5",
    "serialize-javascript": ">=7.0.5",
    "diff": ">=8.0.3",
    "ip-address": ">=10.1.1",
    "@ansys/cloud-angular-client": "npm:@ansys-internal/cloud-angular-client@1.6.1"
  }
}
